import React, { useEffect } from "react";
import debounce from "lodash/debounce";
import styled from "styled-components";
import { colors } from "definitions";

const ARROW_SIZE = 8.48528137;
const VIEWPORT_MARGIN = 8;

/**
 * Globo que se abre por encima de un disparador (`Help`), centrado en él.
 * `coords.left` es el centro del disparador y `coords.top` su borde superior,
 * en coordenadas de la página. `width` es el ancho del globo: si centrado se
 * saliera de la pantalla, se corre hacia adentro y la flecha se mueve sola
 * para seguir apuntando al disparador.
 */
export default function TooltipPopover({
  children,
  coords,
  updateTooltipCoords,
  width = 200,
}) {
  const updateCoords = debounce(updateTooltipCoords, 100);

  useEffect(() => {
    window.addEventListener("resize", updateCoords);
    return () => window.removeEventListener("resize", updateCoords);
  }, [updateCoords]);

  const centered = (coords.left || 0) - width / 2;
  const maxLeft = window.innerWidth - width - VIEWPORT_MARGIN;
  const left = Math.max(VIEWPORT_MARGIN, Math.min(centered, maxLeft));
  const arrowLeft = (coords.left || 0) - left - ARROW_SIZE / 2;

  return (
    <Container style={{ top: coords.top, left, width }}>
      <TooltipContent>
        <TooltipArrow style={{ left: arrowLeft }} />
        <TooltipInner role="tooltip">
          <div>
            <TooltipInnerContent>{children}</TooltipInnerContent>
          </div>
        </TooltipInner>
      </TooltipContent>
    </Container>
  );
}

const Container = styled.div`
  position: absolute;
  transform: translateY(-100%);
  /* Por encima del header (z-index: 1000) y de los modales (1100): el globo
     tiene que quedar sobre lo que sea que tenga debajo, también si el
     disparador está dentro de un modal. */
  z-index: 1150;

  :after {
    position: absolute;
    background: rgba(255, 255, 255, 0.01);
    content: "";
  }
`;
const TooltipArrow = styled.div`
  position: absolute;
  display: block;
  width: ${ARROW_SIZE}px;
  height: ${ARROW_SIZE}px;
  background: transparent;
  border-style: solid;
  border-width: ${ARROW_SIZE / 2}px;
  transform: rotate(45deg);
  bottom: 6.2px;
  border-top-color: transparent;
  border-right-color: ${colors.background.gray};
  border-bottom-color: ${colors.background.gray};
  border-left-color: transparent;
  box-shadow: 3px 3px 7px rgba(0, 0, 0, 0.07);
`;
const TooltipContent = styled.div`
  background-color: ${colors.background.gray};
  padding: 15px;
  margin-bottom: 10px;
  border-radius: 4px;
`;

const TooltipInner = styled.div`
  color: white;
`;
const TooltipInnerContent = styled.div``;
